
import { Link } from 'react-router-dom';

interface ProfileHeaderProps {
  userName: string;
  userEmail: string;
}

const ProfileHeader = ({ userName, userEmail }: ProfileHeaderProps) => {
  return (
    <>
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/ff0b7e80ce034da2f0ffbed7fce4b50d/d817fcc14e7e8fe425753ab5de5ab717.jpeg"
                alt="Vazcular Logo"
                className="h-10 w-auto"
              />
              <span className="text-xl font-semibold text-gray-900">Vazcular</span>
            </Link>
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600 hidden md:block">
                <i className="ri-user-line mr-1"></i>
                {userName || userEmail}
              </span>
              <Link
                to="/"
                className="text-gray-600 hover:text-[#f04e58] transition-colors text-sm flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <section className="bg-gradient-to-br from-[#fef5f5] to-white py-12">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
            Profile Settings
          </h1>
          <p className="text-gray-600 text-sm">
            Manage your account details and preferences
          </p>
        </div>
      </section>
    </>
  );
};

export default ProfileHeader;
